import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, Event, Params, NavigationStart } from '@angular/router';
import $ from 'jquery';
import { UserAccountService } from './user-account.service';
import { GallopLocalStorageService } from './gallop-local-storage.service';
import { Subscription, BehaviorSubject } from 'rxjs';
import { UserAccountInfo } from './entity/user-account-info';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DeleteCardModelComponent } from './email-booking-flow/delete-card-model/delete-card-model.component';
import { deserialize } from './util/ta-json/src/methods/deserialize';
import { TranslateService } from '@ngx-translate/core';
import { CommonUtils } from './util/common-utils';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { SearchService } from './search.service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { DeviceDetailsService } from './device-details.service';
import { ToastrService, ActiveToast } from 'ngx-toastr';
import { ConnectionService } from 'ng-connection-service';
import { InitClientComponent } from './cancel-success/init-client-component';
import { BookingService } from './booking.service';
import { LoginService } from './login.service';
import { ClientConfiguration } from './client-config.service';
import { FeedbackComponent } from './feedback/feedback.component';
import { filter } from 'rxjs/operators';
import { AdminPanelService } from './admin-panel.service';
import { UserCredentialsService } from './user-credentials.service';
import { TabNavigationService } from './services/tab-navigation.service';
import { GroupBookingTimerService, GroupBookingTimerState } from './group-booking-timer.service';
import { GroupBookingHoldGuardService, GROUP_BOOKING_HELD_ROOM_ASSIGNMENTS_KEY } from './group-booking-hold-guard.service';
import { Observable } from 'rxjs';
import { Constants } from './util/constants';
import { PopupComponent } from './popup/popup.component';
import { isJsxSelfClosingElement } from 'typescript';
import { timingSafeEqual } from 'crypto';
import { Role } from './entity/employee-info';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { GallopAnalyticsUtil } from './analytics.service';
export let browserRefresh = false;
declare var sendLogToRollBar:any;
declare var getCurrentlyOpenNgxSmartModalIds: any;
declare var setNgxSmartModalOpenStateClosed: any;
declare var gtag: any;
declare var stopEventsBehindCal: any;
declare var startEventsBehindCal: any;
declare var isNJoySpecificParamInUrl: any;
declare var getStoreAppVersionName: any;
declare var getAppBuildNumber: any;
declare var getAppPlatform: any;
declare var setUPRollBar: any;
declare var setAppLoaded: any;
declare var changeFavicon:any;
declare var applyStyles:any;
declare var initializeHotJar: any;
declare var addingHeader:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  private fetchAccountInfoSubscription: Subscription;
  private travellersFetched = false;
  private adminEmployeesFetched = false;
  private generalSettingFetched = false;
  bsModalRef: BsModalRef;
  bsModalHotelreview: BsModalRef;
  njoySpecificBuild: boolean
  navigatorData = this.getUserBrowserInfo();
  isMobile: boolean = false;
  isMobile1: boolean = false;
  connectionListener: Subscription;
  userInitListner: Subscription;
  userDetailsSubscription: Subscription;
  private currentUrl: string = '';
  private currentParams: any;
  public currDatePicker;
  public  userAccountInfoObj: UserAccountInfo;
  private isNavigating = false; // Add flag to prevent redirection loops
  private _pendingRedirectToken: string | null = null; // Captured early before Angular routing strips it
  private _pendingReturnPath: string | null = null; // Original path to restore after cross-portal redirect
  private _pendingQueryParams: { [key: string]: string } | null = null; // All params captured before Angular's redirectTo strips them
  constructor(
    private translate: TranslateService,
    private toastr: ToastrService,
    private loginService: LoginService,
    private adminPanelService: AdminPanelService,
    public userAccountService: UserAccountService,
    private deviceDetailsService: DeviceDetailsService,
    private modalService: BsModalService,
    public connectionService: ConnectionService,
    private ngxAnaltics:GoogleAnalyticsService,
    private gallopLocalStorage: GallopLocalStorageService,
    private route: ActivatedRoute, private router: Router,
    public ngxSmartModalService: NgxSmartModalService,
    public searchService: SearchService,
    private titleService: Title,
    public bookingService: BookingService,
    private userCredentials: UserCredentialsService,
    public el: ElementRef,
    public clientConfig: ClientConfiguration,
    public renderer: Renderer2,
    private tabNavigationService: TabNavigationService,
    public groupTimerSvc: GroupBookingTimerService,
    public groupBookingHoldGuard: GroupBookingHoldGuardService) {
    renderer.listen('document', 'click', (event) => {
      let action = event.target.getAttribute('attr.data-track');
      let params1 = event.target.getAttribute('attr.data-params') ? ('&' + 'ua_' + event.target.getAttribute('attr.data-params')) : '';
      let params2 = event.target.getAttribute('data-params') ? ('&' + 'ua_' + event.target.getAttribute('data-params')) : '';
      if (params2) {
        let params = '?' + 'ua_action=' + action + params2;
        this.searchService.letsTrack(params);
      }
      else if (action) {
        let params = '?' + 'ua_action=' + action + params1;
        this.searchService.letsTrack(params);
      }
  
    //  this.connectionListener = this.connectionService.monitor().subscribe(isConnected => {
       
    //  });
     
    });
    localStorage.getItem('loginSession')
    this.njoySpecificBuild = this.userAccountService.isItNjoyBuild();
    if (isNJoySpecificParamInUrl()) {
      this.userAccountService.njoySpecificBuild = true;
      this.njoySpecificBuild = true;
    }
    environment.appStoreVersionName = getStoreAppVersionName();
    environment.appStoreBuildNumber = getAppBuildNumber();
    environment.platform = getAppPlatform();
    const navEndEvent$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd));
    // Capture redirect_token and returnPath early from the raw URL before Angular's redirectTo strips query params
    const earlyParams = new URLSearchParams(window.location.search);
    const earlyToken = earlyParams.get('redirect_token');
    if (earlyToken) {
      this._pendingRedirectToken = earlyToken;
    }
    const earlyReturnPath = earlyParams.get('returnPath');
    if (earlyReturnPath) {
      this._pendingReturnPath = earlyReturnPath;
    }
    // Capture all query params early before Angular's redirectTo strips them
    const allEarlyParams: { [key: string]: string } = {};
    earlyParams.forEach((value, key) => {
      allEarlyParams[key] = value;
    });
    if (Object.keys(allEarlyParams).length > 0) {
      this._pendingQueryParams = allEarlyParams;
    }
  }
  
  
  
  setUpAppMode() {
    this.njoySpecificBuild = this.userAccountService.isItNjoyBuild();
    environment.appStoreVersionName = getStoreAppVersionName();
    environment.appStoreBuildNumber = getAppBuildNumber();
    environment.platform = getAppPlatform();
    const appMode = localStorage.getItem('is_app_mode');
    if (appMode){
      this.userAccountService.njoySpecificBuild = true;
      this.njoySpecificBuild = true;
      document.body.classList.add('app-mode');
      return;
    }
    if (isNJoySpecificParamInUrl()) {
      this.userAccountService.njoySpecificBuild = true;
      this.njoySpecificBuild = true;
      localStorage.setItem('is_app_mode','true');
      document.body.classList.add('app-mode');
    }
  }
  setHtmlBackground(): void {
    const htmlElement = document.querySelector('html');
    if (htmlElement && this.njoySpecificBuild) {
      this.renderer.setStyle(htmlElement, 'overscroll-behavior', 'none');
    }
  }

  ngOnInit() {
    let whitelLabelSetting = JSON.parse(localStorage.getItem('whiteLabelSetting'));
    if(whitelLabelSetting && whitelLabelSetting!=='null'){
      this.setWhiteLabelSetting(whitelLabelSetting)
    }else{
      CommonUtils.changeDeafultWhiteKabeling(this.searchService,this.userAccountService,this.router);
      
    }
    this.setUpAppMode();
    setAppLoaded();
    addingHeader();
  
    this.searchService.calendarOpenEventListsner.asObservable().subscribe(datePicker => {
      this.currDatePicker = datePicker;
      this.searchService.hoverCounter = 0;
      if (this.currDatePicker) {
        stopEventsBehindCal();
      } else {
        setTimeout(() => {
          startEventsBehindCal();
        }, 500);
      }
    })
    let timeNow = Date.now();
    this.connectionListener = this.connectionService.monitor().subscribe(isConnected => {
      let timeNowNoW = Date.now();
      timeNow = timeNowNoW;
    
    });
    let self = this;
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === 'visible') {
        self.userAccountService.appVisibleToUser = true;
       
         
        
      } else {
        self.userAccountService.appVisibleToUser = false;
      }
    });
    
   

    this.gallopLocalStorage.initAppSessionKey();
    // Clears leftover group-booking hotel selection data from a previous tab session
    // (e.g. a refresh mid-hold) - same keys already cleared on release/reset below.
    this.gallopLocalStorage.clearOrphanedKeys(['selectedHotel', 'selectedHotelDetailedObj', GROUP_BOOKING_HELD_ROOM_ASSIGNMENTS_KEY]);
    this.userAccountService.userSessionChangePrompt$.subscribe((loginDetails: any) => {
      if (loginDetails && loginDetails['userid'] && loginDetails['sToken'] && loginDetails['userInfo']) {
        let userInfoObj: UserAccountInfo = deserialize(loginDetails['userInfo'], UserAccountInfo);
        if (!this.isLogoutPage()) {
          this.promptContinueLogin(loginDetails['userid'], loginDetails['sToken'], userInfoObj);
        }
      } else {
        // this.attemptLoginSessionUpdate(undefined,undefined,this.currentUrl);
      }
    });
    this.userAccountService.userAccountInitObjObserver$.subscribe(resp => {
      if (resp && resp.status === 'success') {
        this.loginService.initResponse =resp;
        if ((resp && resp.status === 'success')
          && (
            resp.responseType === 'AllowedToProceed' ||
            resp.responseType === 'NotAllowedToProceed' ||
            resp.responseType === 'AllowedToProceedWithCTA' ||
            resp.responseType === 'NotAllowedToProceedWithCTA'
          )
        ) {
          let ctaTextString = undefined;
          let ctaString = undefined;
          //if(resp && resp.confermaStatus){

          // }
          if (resp.responseType !== 'AllowedToProceedWithCTA' ||
            resp.responseType !== 'NotAllowedToProceedWithCTA'
          ) {
            ctaTextString = resp.ctaText;
            ctaString = resp.cta;
          }

          this.bsModalRef = this.modalService.show(InitClientComponent, {
            initialState: {
              message: resp.errorMessage,
              responseType: resp.responseType,
              cta: ctaString,
              ctaText: ctaTextString
            }, backdrop: true, keyboard: false, ignoreBackdropClick: true
          });
        }
        if(resp.defaultConfig){
          this.searchService.mapSupprted = resp.defaultConfig.mapsSupported;
       
          this.searchService.groupTravelEventsSupported = resp.defaultConfig.groupTravelEventsSupported;
          this.searchService.groupHotelBookingEnabled = resp.defaultConfig.groupHotelBookingEnabled;
          this.searchService.showFlightTab = resp.defaultConfig.flightsEnabled;
          this.searchService.showCarTab = resp.defaultConfig.carsEnabled;
          this.searchService.showHotelTab = resp.defaultConfig.hotelsEnabled;
          this.searchService.addEntitySupported = resp.defaultConfig.addEntityFeature;
          this.searchService.logoIcon = resp.defaultConfig.logoIcon;
          this.searchService.searchPopMsg= resp.defaultConfig.searchLoaderText;
          this.searchService.whiteLabelSupported = resp.defaultConfig.whiteLabelSupported;
          if (resp.defaultConfig && resp.cardIssuingHandler) {
            this.userAccountService.cardIssuingHandler = resp.cardIssuingHandler;
          }
          if(this.searchService.whiteLabelSupported){
            this.callDynamicColorOfApp();
          }else{
            localStorage.setItem('whiteLabelSetting',null);
            CommonUtils.changeDeafultWhiteKabeling(this.searchService,this.userAccountService,this.router);
        
          }
          if(this.searchService.searchPopMsg && this.searchService.searchPopMsg.length > 0){
            this.searchService.currentMessage = this.searchService.searchPopMsg[0];
          }
          this.userAccountService.hotelManagerEnabled = resp.defaultConfig.hotelManagerEnabled === true;
          this.userAccountService.hotelManagerCompanyEnabled = resp.defaultConfig.hotelManagerCompanyEnabled === true;
          this.userAccountService.bulkModificationEnabled = resp.defaultConfig.bulkModificationEnabled === true;
          // Anything but an explicit WRITE is view-only - least privilege, so a thin or older init
          // response can never hand a user write affordances. [Trello 21680]
          this.userAccountService.hotelManagerPermission =
            String(resp.defaultConfig.hotelManagerPermission || '').toUpperCase() === 'WRITE' ? 'WRITE' : 'READ';
          this.userAccountService.showComingSoonIntegrations=  resp.defaultConfig.showComingSoonIntegrations;
          this.searchService.perDiemSupported = resp.defaultConfig.perDiemSupported;
          this.searchService.chatEnabled = resp.defaultConfig.chatEnabled;
          this.searchService.splitPaymentsEnabled = resp.defaultConfig.splitPaymentsEnabled;
          this.searchService.showTrainsTab = resp.defaultConfig.trainsEnabled;
        }
        if(resp.customReportsInterval){
          this.searchService.customReportsInterval = resp.customReportsInterval;
        }
        if(resp.reportDeprecationDate){
          this.searchService.reportDeprecationDate = resp.reportDeprecationDate;
        }
        this.searchService.euroStarSupported = resp.euroStarSupported;
        this.searchService.allFaresPopupShow = resp.upSellFareSupported;
        this.userAccountService.showLanguageOptions = resp.showLanguageOptions;
        this.userAccountService.showAllBookings = resp.showAllBookings;
        this.userAccountService.showUpSellOnAllLegs = resp.showUpSellOnAllLegs;
        this.userAccountService.initResponseReceived = true;
        this.userAccountService.confermaStatus = resp.confermaStatus;
        this.userAccountService.cardIssuingHandler = resp.cardIssuingHandler;
        if(resp.hotelChangesSupportedFor){
        this.searchService.hotelChangesSupportedFor = resp.hotelChangesSupportedFor;
        }
        if (resp.onBoarded) {
          this.userAccountService.onBoardingTask = resp.onBoarded;
        }
        if (resp.cardSupportEnabled) {
          this.userAccountService.userhascard = resp.cardSupportEnabled;
        }
        if (resp.defaultConfig && resp.cardIssuingHandler) {
          this.userAccountService.cardIssuingHandler = resp.cardIssuingHandler;
        }
        if (resp.hotelDetailForFeedback) {
          if (this.loginService.userid && this.loginService.sToken && !this.bsModalHotelreview) {
            this.bsModalHotelreview = this.modalService.show(FeedbackComponent, {
              initialState: {
                hotelName: resp.hotelDetailForFeedback.hotelName,
                checkin: resp.hotelDetailForFeedback.checkIn,
                checkout: resp.hotelDetailForFeedback.checkout,
                tripId: resp.hotelDetailForFeedback.tripId,
                transactionId: resp.hotelDetailForFeedback.transactionId,
                eventId: resp.hotelDetailForFeedback.eventId,
                ticketId: resp.hotelDetailForFeedback.ticketId,
              }, backdrop: true, keyboard: false, ignoreBackdropClick: true
            });
          }
        }
        if (resp.pendingImpersonationRequest) {
          this.userAccountService.pendingAuthRequest$.next(resp.pendingImpersonationRequest);
        }
        if (resp.activeImpersonationSession) {
          this.userAccountService.approvedSession$.next({
            requestId: resp.activeImpersonationSession.requestId,
            agentName: resp.activeImpersonationSession.agentName,
            agentId: resp.activeImpersonationSession.agentId,
            expiresAt: resp.activeImpersonationSession.expiresAt
          });
        }
        if (resp.impersonationConfig && resp.impersonationConfig.authorizationRequestExpirationMinutes) {
          this.userAccountService.authorizationRequestExpirationMinutes = resp.impersonationConfig.authorizationRequestExpirationMinutes;
        }
        if (resp.impersonationConfig && resp.impersonationConfig.approvedSessionDurationMinutes) {
          this.userAccountService.approvedSessionDurationMinutes = resp.impersonationConfig.approvedSessionDurationMinutes;
        }
        this.userAccountService.isCarsEnabled = resp.carsEnabled;
        environment.locationSupportedInCarSearch = resp.locationSupportedInCarSearch;
        environment.presentAlternateInPolicyOptions = resp.presentAlternateInPolicyOptions;
        this.userAccountService.isDutyOfCareEnabled = resp.dutyOfCareEnabled;

        setUPRollBar(resp.rollBarApiKey, resp.rollBarEnvironment);
        // Going forward we will use config service for configuration related things
        this.clientConfig.carsEnabled = resp.carsEnabled;
        this.clientConfig.locationSupportedInCarSearch = resp.locationSupportedInCarSearch;
        this.clientConfig.presentAlternateInPolicyOptions = resp.presentAlternateInPolicyOptions;
        this.clientConfig.dutyOfCareEnabled = resp.dutyOfCareEnabled;
        this.clientConfig.classicReports = resp.classicReports;
        this.clientConfig.expiringCreditsView = resp.expiringCreditsView === true;
        this.clientConfig.bookingAppBaseUrl = resp.bookingAppBaseUrl;
        this.clientConfig.dashboardAppBaseUrl = resp.dashboardAppBaseUrl;
        this.clientConfig.tmAppBaseUrl = resp.tmAppBaseUrl;
        this.clientConfig.enableReconcile = resp.enableReconcile;
        this.clientConfig.agentEmailId = resp.agentEmailId;
        this.clientConfig.brandName = resp.brandName;
        if (this.clientConfig.bookingAppBaseUrl && this.clientConfig.bookingAppBaseUrl.endsWith('/')) {
          this.clientConfig.bookingAppBaseUrl
            = this.clientConfig.bookingAppBaseUrl.substring(0, this.clientConfig.bookingAppBaseUrl.length - 1);
        }
        if (this.clientConfig.dashboardAppBaseUrl && this.clientConfig.dashboardAppBaseUrl.endsWith('/')) {
          this.clientConfig.dashboardAppBaseUrl
            = this.clientConfig.dashboardAppBaseUrl.substring(0, this.clientConfig.dashboardAppBaseUrl.length - 1);
        }
        if (this.clientConfig.tmAppBaseUrl && this.clientConfig.tmAppBaseUrl.endsWith('/')) {
          this.clientConfig.tmAppBaseUrl
            = this.clientConfig.tmAppBaseUrl.substring(0, this.clientConfig.tmAppBaseUrl.length - 1);
        }
        // On refresh, redirect user to the correct portal if needed
        this.checkAndRedirectToCorrectPortal();
        const selectedLang = localStorage.getItem('selectedLanguage');
        if (selectedLang && this.userAccountService.showLanguageOptions) {
          this.translate.use(selectedLang);
          this.userCredentials.setLang(selectedLang);
        }
        // Only fetch booking lists if user is logged in with valid credentials
        if (this.userAccountService.isLoggedIn() && this.userAccountService.getUserEmail() && this.userAccountService.getSToken()) {
          this.userAccountService.getBookingListForMyTripsPage();
        }
        if (this.userAccountService.getUserEmail()) {
          this.navigatorData['id'] = this.userAccountService.getUserEmail().replace('@', '_').replace('.', '_');
        }
        // sendLogToRollBar(JSON.stringify(this.navigatorData));
        if(this.userAccountService.isLoggedIn() && this.userAccountService.getUserEmail() && this.userAccountService.getSToken() && this.userAccountService.isShowAllBookings()) {
          this.userAccountService.getBookingList();
        }

      }
    });
  
    //let emailid = this.gallopLocalStorage.getItem("userid");
    this.searchService.getMappingStars().subscribe(res =>{
      if(res && res.data){
       
        this.searchService.NGS_UI_STAR_MAPPING = res.data;
      }
    })
    //let stoken = this.gallopLocalStorage.getItem("sToken");
    this.router.events.subscribe((event: Event) => {
      // if(this.userAccountService.isLoggedIn()) return;
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.searchService.isSearchPage = CommonUtils.isBookingPagePath(this.currentUrl);
        this.userAccountService.updateCurrentRouterPath(event.url);
       
        this.currentParams = this.route.snapshot.queryParams;
        // Restore any query params that Angular's redirectTo may have stripped
        if (this._pendingQueryParams) {
          this.currentParams = { ...this._pendingQueryParams, ...this.currentParams };
          this._pendingQueryParams = null;
        }

          this.checkForEventId()

       

         const redirectToken = this.route.snapshot.queryParamMap.get('redirect_token') || this._pendingRedirectToken;
         const stoken = this.route.snapshot.queryParamMap.get('sToken');         
         const userid_param = this.route.snapshot.queryParamMap.get('emailId');
         if(stoken && event.url.includes('pageMode')){
          const pageMode = this.route.snapshot.queryParamMap.get('pageMode');
          localStorage.setItem("pageMode",pageMode)
         }
          if(stoken && !event.url.includes('emailflow')){
           this.removeQueryParam('sToken');
          } else if (stoken && event.url.includes('emailflow') && userid_param) {
            // Handle emailflow with stoken - verify credentials but keep stoken in URL
            this.loginService.userid = userid_param;
            this.loginService.sToken = stoken;
            this.userCredentials.setUserId(userid_param);
            this.userCredentials.setSToken(stoken);

            // Verify credentials and initialize for emailflow
            this.verifyAndInitializeUser(userid_param, stoken, this.loginService.uRole);
            return; // Skip attemptLoginSessionUpdate
          }

          if (redirectToken) {
          this._pendingRedirectToken = null; // Consumed — prevent re-processing
          const result = CommonUtils.decodeRedirectToken(redirectToken);
          if (result) {
            const { userid, sToken } = result;
            //  Optionally remove from URL
             this.loginService.userid  = userid;
             this.loginService.sToken=  sToken;
             this.userCredentials.setUserId(userid);
             this.userCredentials.setSToken(sToken);

             // Verify credentials and initialize directly
             this.verifyAndInitializeUser(userid, sToken, this.loginService.uRole);

            this.removeQueryParam('redirect_token');
            return; // Skip attemptLoginSessionUpdate
          }
        }
        let userid = this.currentParams['userid'] ? this.currentParams['userid'] : this.loginService.userid;
        let sToken = this.currentParams['sToken'] ? this.currentParams['sToken'] : this.loginService.sToken;
        let uRole = this.loginService.uRole;
        if (!userid) userid = this.currentParams['emailId'];
        // Only call attemptLoginSessionUpdate if no sToken in URL
        if (!this.isLogoutPage() && !this.loginService.sToken) {
          this.attemptLoginSessionUpdate(userid, sToken, uRole,this.currentUrl);
        }
        if(this.isLoginOrLogoutPage()){
          this.userAccountService.showLanguageOptions =true;
        }
      }

      if (event instanceof NavigationStart) {
        browserRefresh = !this.router.navigated;
        if(CommonUtils.isThisDashboard(this.router)){
          $('html').addClass('global_zoom_for_dashboard');
          this.loadZoomConfig();
          const style = document.createElement('style');
          style.innerHTML = `
            body > .pac-container{
              width: 60% !important;
              transform: translateY(-15px);
              max-width:980px;
            }
            @media (max-width: 1500px) {
            body > .pac-container{
                  max-width:775px;
              }
            }
          `;
          document.head.appendChild(style);
        }else{
          $('html').removeClass('global_zoom_for_dashboard');
        }
        if((event.url==='/hotelSelection' || event.url==='/emailflow?pageMode=WebSearch') && browserRefresh){
             this.goToHomePage();
        }
        if(event.url==='/emailflow?pageMode=WebSearch'){
          this.searchService.comingFromSelectionPAge = true;
        }
        if (event.navigationTrigger === 'popstate' && event.restoredState) {
          this.searchService.browserBackOrForwardClickListener.next(null);
        }

      }
    });
    this.userAccountService.userAccountInfoObjObserver$.subscribe((userProfile: UserAccountInfo) => {

      if (!userProfile) {
        // User logged out — reset one-time fetch guards so they fire again on next login
        this.travellersFetched = false;
        this.adminEmployeesFetched = false;
        this.generalSettingFetched = false;
        return;
      }
      // userProfile is guaranteed truthy here (falsy case returns above)
      // On refresh, redirect user to the correct portal if needed
      this.checkAndRedirectToCorrectPortal();
      this.setHtmlBackground();
      // fetchInviteList is handled by search.component.ts which has the full event modal logic.
      // Removed from here to prevent duplicate /travel_group_events/attendees/invites/list calls.

      if (!this.generalSettingFetched) {
        this.generalSettingFetched = true;
        this.getGeneralSetting();
      }
      if (this.userAccountService.showRadio) {
        if (this.userAccountService.isConnected && this.currentUrl !== '/emailflow?pageMode=WebSearch') {
          if (!this.travellersFetched) {
            this.travellersFetched = true;
            this.searchService.fetchEmployeesList(this.userAccountService.getUserCompanyId());
          }
          if (!this.adminEmployeesFetched) {
            this.adminEmployeesFetched = true;
            this.adminPanelService.fetchEmployeesList(this.userAccountService.getUserCompanyId());
          }
          if ((this.userAccountService.isUserIsTravelManager() || this.userAccountService.isUserCorporateAdmin())
              && !this.bookingService.previousTransactionId
              // Rebook & Cancel: don't wipe the picker while a rebook traveller is pending — the
              // in-place-cancel path clears previousTransactionId, so this admin/TM guard would
              // otherwise treat a rebook as a normal fresh search and clear the pre-selection.
              && !(!this.searchService.searchStart && this.bookingService.rebookingTravlleremail && this.bookingService.rebookingTravlleremail.length > 0)) {
            this.searchService.employeeEmail = [];
            if (this.route.snapshot.queryParams['query']) {
              this.searchService.bookingAndApprovalDone = true;
            }
          }
        }
      }


    });
    window.addEventListener('storage', this.storageEventListener.bind(this));
    this.deviceDetailsService.isMobile().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
    this.deviceDetailsService.isMobile2().subscribe(isMobile => {
      this.isMobile1 = isMobile;
    });

    if (!CommonUtils.doesPathContain(location.href, '/login')
        &&
        !CommonUtils.doesPathContain(location.href, '/admin')
      ) {
        initializeHotJar(environment.hj_site_id_booking);
    }

    // Fix for tab navigation issue in production builds
    this.setupTabNavigationFix();
    if(this.isDashboardPage()){
      this.loadZoomConfig();
    }
  }

  private setupTabNavigationFix() {
    // Use the dedicated tab navigation service to fix production build issues
    this.tabNavigationService.initializeTabNavigation();
  }

 calculateManualZoom(input: string | number): number {
    let cleanValue = String(input).replace('%', '').trim();
    let numericValue = parseFloat(cleanValue);
    if (isNaN(numericValue)) return 1;
    return numericValue / 100;
}



loadZoomConfig(): void {
    fetch('assets/zoom-config.json')
      .then(res => res.json())
      .then(config => {
        const data = config?.data;
        if (!data) return;
        const root = document.documentElement.style;
        root.setProperty('--font--zoom-value', String(this.calculateManualZoom(data.fontZoomValue ?? '80%')));
        root.setProperty('--width--zoom-value', String(this.calculateManualZoom(data.widthZoomValue ?? '80%')));
        root.setProperty('--height--zoom-value', String(this.calculateManualZoom(data.heightZoomValue ?? '80%')));
        root.setProperty('--margin--zoom-value', String(this.calculateManualZoom(data.marginZoomValue ?? '80%')));
        root.setProperty('--padding--zoom-value', String(this.calculateManualZoom(data.paddingZoomValue ?? '80%')));
        root.setProperty('--border--zoom-value', String(this.calculateManualZoom(data.borderZoomValue ?? '80%')));
        root.setProperty('--border--radius--zoom-value', String(this.calculateManualZoom(data.borderRadiusZoomValue ?? '80%')));
        root.setProperty('--gap--zoom-value', String(this.calculateManualZoom(data.gapZoomValue ?? '80%')));
        root.setProperty('--position--zoom-value', String(this.calculateManualZoom(data.positionZoomValue ?? '80%')));
        root.setProperty('--icon--zoom-value', String(this.calculateManualZoom(data.iconZoomValue ?? '80%')));
        root.setProperty('--line--height--zoom-value', String(this.calculateManualZoom(data.lineHeightZoomValue ?? '80%')));
        root.setProperty('--chart--width--zoom-value', String(this.calculateManualZoom(data.chartWidthZoomValue ?? '100%')));
        root.setProperty('--chart--height--zoom-value', String(this.calculateManualZoom(data.chartHeightZoomValue ?? '100%')));
        root.setProperty('--calender--zoom-value',String(this.calculateManualZoom(data.calenderZoomValue ?? '100%')));
        root.setProperty('--notification--zoom-value', String(this.calculateManualZoom(data.notificationZoomValue ?? '100%')));
        root.setProperty('--approvals--zoom-value', String(this.calculateManualZoom(data.approvalsZoomValue ?? '100%')));
        root.setProperty('--booking-detail--zoom-value', String(this.calculateManualZoom(data.bookingDetailZoomValue ?? '100%')));
        root.setProperty('--see-details-modal--zoom-value', String(this.calculateManualZoom(data.seeDetailsModalZoomValue ?? '100%')));
          
      })
      .catch(err => {
        console.warn('Failed to load zoom-config.json, using defaults', err);
      });
}

  goToHomePage() {
    let redirect_token = CommonUtils.base64EncodeRedirectToken(this.userAccountService.getUserEmail(),this.userAccountService.getSToken());
    if((this.userAccountService.isUserCorporateAdmin() || this.userAccountService.isUserIsTravelManager())){
      this.searchService.employeeEmail=[];
      this.searchService.bookingAndApprovalDone =true;
    }
    if (this.userAccountService.getDefaultAppRoutePath() !== '/admin') {
      this.isNavigating = true;
      this.currentParams = this.route.snapshot.queryParams;

      this.checkForEventId()
      if(this.searchService.selectedEventID){
        this.router.navigate([this.userAccountService.getDefaultAppRoutePath()],{ queryParams: { redirect_token: redirect_token,eventid:this.searchService.selectedEventID },
        replaceUrl: true }).then(() => {this.isNavigating = false;});
      }else{
      this.router.navigate([this.userAccountService.getDefaultAppRoutePath()],{ queryParams: { redirect_token: redirect_token },
       replaceUrl: true }).then(() => {this.isNavigating = false;});
  }
  }
  }
  removeQueryParam(paramName: string) {
    const queryParams = { ...this.route.snapshot.queryParams };
    delete queryParams[paramName];
    if(queryParams['sToken']){
      delete queryParams['sToken'];
    }
    if(queryParams['userid']){
      delete queryParams['userid'];
    }
   
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      replaceUrl: true,
    });
  
  }
  changeStyle() {
    if (this.airportModalOpen()) {
      return { 'min-height': '0px', 'padding-bottom': '0px' };
    } else {
      if(this.isDashboardPage()){
        return { 'min-height': '125vh', 'padding-bottom': '100px' };
      }else{
        return { 'min-height': '100%', 'padding-bottom': '100px' };
      }
      
    }
  }
  
  
  changeStyle1() {
    if (this.airportModalOpen()) {
      return { 'min-height': '0px' };
    } else {
        return { 'min-height': '100vh' };
        
    }
  }
  setWhiteLabelSetting(resp){
      if(resp && resp.status==='success'){
        if(resp.data && resp.data.backGroundColor){
       
          if (resp.data.backGroundColor){
            this.searchService.darkBgColor = resp.data.backGroundColor;
          }else{
            this.searchService.darkBgColor = '8A27F7';
          }
          if (resp.data.secondaryBrandColor){
            this.searchService.secondaryBgColor = resp.data.secondaryBrandColor;
          }else{
            if(resp.data.primaryButtonColor){
              this.searchService.secondaryBgColor  = resp.data.primaryButtonColor;
            }else{
              this.searchService.secondaryBgColor = '29EED8';
            }
          }
          if (resp.data.favIcon){
            this.searchService.favIcon = resp.data.favIcon;
          }else{
            this.searchService.favIcon = 'src/favicon.ico';
          }
          if (resp.data.primaryButtonColor){
            this.searchService.buttonbgcolor = resp.data.primaryButtonColor;
          }else{
            this.searchService.buttonbgcolor = '8936F3';
          }
          if (resp.data.primaryButtonTextColor){
            this.searchService.buttonfontcolor = resp.data.primaryButtonTextColor;
          }else{
            this.searchService.buttonfontcolor = 'FFFFFF';
          }
          if (resp.data.primaryButtonTextColor){
            this.searchService.buttonfontcolor = resp.data.primaryButtonTextColor;
          }else{
            this.searchService.buttonfontcolor = 'FFFFFF';
          }
          this.searchService.hyperlinkcolor = this.searchService.buttonbgcolor;
          if (resp.data.primaryBrandColor){
            this.searchService.lightBgColor =resp.data.primaryBrandColor;
          }else{
            this.searchService.lightBgColor = 'FFFFFF';
          }
           if (resp.data.companyLogo){
            this.searchService.logo = resp.data.companyLogo;
          }else{
            this.searchService.logo = 'assets/images/logo.png';
          }
        if (resp.data.footerLogo){
          this.searchService.footerLogo = resp.data.footerLogo;
          }else{
            this.searchService.footerLogo = 'assets/images/footer-logo.png';
          }
          if (resp.data.companyLogoForDashboard){
            this.searchService.logo2 = resp.data.companyLogoForDashboard;
          }else{
          this.searchService.logo2 = 'assets/images/logo.webp';
          }
       
       applyStyles(resp);
        }else{
          
       CommonUtils.changeDeafultWhiteKabeling(this.searchService,this.userAccountService,this.router);
        
      }
    }
  }
         
  callDynamicColorOfApp(){
    this.userAccountService.getWhiteLableColor().subscribe(resp => {
      if(resp && resp.status==='success'){
        if(resp.data && resp.data.backGroundColor){
      localStorage.setItem('whiteLabelSetting',JSON.stringify(resp));
        }else{
          localStorage.setItem('whiteLabelSetting',null);
        }
      }
      this.setWhiteLabelSetting(resp);
    })
  }
  getGeneralSetting(){
    this.searchService.getGeneralSetting().subscribe(resp =>{
      if(resp && resp.status==='success'){
        if(resp.data && resp.data.language){
          this.useLanguage(resp.data.language);
        }
       
      }
    })
  }
  useLanguage(language: string) {
    // Validate language before using it
    if (!Constants.SUPPORTED_LANGUAGES.includes(language)) {
      console.warn(`Unsupported language '${language}' requested. Using default 'en'.`);
      language = 'en';
    }

    this.translate.use(language);
    this.userCredentials.setLang(language);
    const oldLang: string = localStorage.getItem('selectedLanguage');
    localStorage.setItem('selectedLanguage', language);
    if (oldLang) {
      localStorage.setItem('oldLanguage', oldLang);
    }
    GallopAnalyticsUtil.trackActionWithCategory(this.ngxAnaltics, 'languageChanged', 'WebSearchUI');
  }
  
  isLoginPage() {
    return this.userAccountService.getCurrentRouterPath().indexOf('login') === 1;
  }
  isSlackconnectRequested() {
   
    return this.userAccountService.getCurrentRouterPath().indexOf('addToSlack') === 1;
  }
  isLoginOrLogoutPage() {
    return this.userAccountService.getCurrentRouterPath().indexOf('login') === 1
      || this.userAccountService.getCurrentRouterPath().indexOf('logout') === 1;
  }
  isLogoutPage() {
    return this.userAccountService.getCurrentRouterPath().indexOf('logout') === 1;
  }
  isGroupBookingOnHotelPage(): boolean {
    return this.router.url.startsWith('/hotelSelection');
  }

  isDashboardPage() {
    if(this.userAccountService.getCurrentRouterPath()){
    return this.userAccountService.getCurrentRouterPath().indexOf('admin') === 1;
  }
  }

  private promptContinueLogin(newUserId: string, newSToken: string, userInfoObj: UserAccountInfo) {
    let currentSessionUser: string = undefined;
    let currentSessionUserRole: string = undefined;
    if (localStorage.getItem('loginSession') !== 'null' && localStorage.getItem('loginSession')) {
      let prevLoginSession = JSON.parse(localStorage.getItem('loginSession'));
      currentSessionUser = prevLoginSession['userid'];
      currentSessionUserRole = prevLoginSession['uRole'];
    }
    if (currentSessionUser && currentSessionUser !== newUserId) {
      if (this.bsModalRef
        && this.bsModalRef.content
        && this.bsModalRef.content.title
        && this.bsModalRef.content.title ===  this.translate.instant('search.Areyousureyouwanttoproceed?')) {
        return;
      }

      this.bsModalRef = this.modalService.show(DeleteCardModelComponent, {
        initialState: {
          title: this.translate.instant('search.Areyousureyouwanttoproceed?'),
          message:  this.translate.instant('search.Youwillbesignedoutof')+ currentSessionUser +  this.translate.instant('search.andsignedinto') + newUserId +  this.translate.instant('search.account'),
          yesButtonSubText:  this.translate.instant('search.Yes'),
          noButtonSubText:  this.translate.instant('search.No'),
          color: 'black',
          login:true,
          buttonColor: this.searchService.hyperlinkcolor
        }, backdrop: true, keyboard: false, ignoreBackdropClick: true
      });
      this.bsModalRef.content.onClose.subscribe(result => {
        this.bsModalRef = null;
        if (result) {
          // Verify credentials before updating session
          this.userAccountService.verifyCredentials(newUserId, newSToken).subscribe(response => {
            if (response && response.success) {
              this.userAccountService.updateUserSession(newUserId, newSToken, currentSessionUserRole,userInfoObj);
              window.location.reload()
            } else {
              console.error('Credential verification failed:', response);
              if (response.status === 403) {
                // Call signout utility for 403 errors
                CommonUtils.signout(this.userAccountService, this.gallopLocalStorage, this.loginService);
              }
              // Navigation to login is already handled in verifyCredentials for 403
              if (response.status !== 403) {
                this.userAccountService.clearLoggedInData();
                this.router.navigateByUrl('/login');
              }
            }
          });
        } else {
          this.titleService.setTitle(this.translate.instant('search.FlightSearch'));
          this.loginService.navigateToPortalOrDefault(currentSessionUserRole, {});
        }
      });
    } else {
      // Verify credentials before updating session
      this.userAccountService.verifyCredentials(newUserId, newSToken).subscribe(response => {
        if (response && response.success) {
          this.userAccountInfoObj = userInfoObj;
          this.userAccountService.updateUserSession(newUserId, newSToken, currentSessionUserRole,userInfoObj);
          if (this.isLoginOrLogoutPage()) {
            console.log('[DEBUG-RETURNPATH] Session restore on login page. loginService.currentUrl =', this.loginService.currentUrl);
            if (this.loginService.currentUrl && this.loginService.currentUrl.trim().length > 0) {
              console.log('[DEBUG-RETURNPATH] Session restore → navigateByUrl to', this.loginService.currentUrl);
              this.router.navigateByUrl(this.loginService.currentUrl);
            } else {
              console.log('[DEBUG-RETURNPATH] Session restore → navigateToPortalOrDefault (no currentUrl)');
              this.titleService.setTitle(this.translate.instant('search.FlightSearch'));
              this.loginService.navigateToPortalOrDefault(currentSessionUserRole, {});
            }
          }
        } else {
          console.error('Credential verification failed:', response);
          if (response.status === 403) {
            // Call signout utility for 403 errors
            CommonUtils.signout(this.userAccountService, this.gallopLocalStorage, this.loginService);
          }
          // Navigation to login is already handled in verifyCredentials for 403
          if (response.status !== 403) {
            this.userAccountService.clearLoggedInData();
            this.router.navigateByUrl('/login');
          }
        }
      });
    }
  }

  isuserHascard(): boolean {
    return this.userAccountService.userhascard;
  }
   getUserBrowserInfo() {
    return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        languages: navigator.languages,
        platform: navigator.platform,
        cookiesEnabled: navigator.cookieEnabled,
        onlineStatus: navigator.onLine,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screenResolution: `${window.screen.width}`+'X'+`${window.screen.height}`,
        colorDepth: window.screen.colorDepth,
        pixelRatio: window.devicePixelRatio,
        serviceWorker: 'serviceWorker' in navigator,
        localStorage: !!window.localStorage,
        sessionStorage: !!window.sessionStorage,
        indexedDB: !!window.indexedDB,
    };
}
  private attemptLoginSessionUpdate(userid: string, sToken: string, uRole:string,currentUrl: string) {
    let currentSessionUser: string = undefined;
    let currentSessionSToken: string = undefined;
    let currentSessionUserRole: string = uRole;
    if (!CommonUtils.doesPathContain(currentUrl, 'emailAction') && !CommonUtils.doesPathContain(currentUrl, 'signup')) {
      if (localStorage.getItem('loginSession') !== 'null' && localStorage.getItem('loginSession')) {
        let prevLoginSession = JSON.parse(localStorage.getItem('loginSession'));
        currentSessionUser = prevLoginSession['userid'];
        currentSessionSToken = prevLoginSession['sToken'];
        currentSessionUserRole = prevLoginSession['uRole'];
        this.loginService.userid = prevLoginSession['userid'];
        this.loginService.sToken = prevLoginSession['sToken'];
        this.loginService.uRole = prevLoginSession['uRole'];
      }
      if (userid && sToken) {
        const dataConsentRequired = localStorage.getItem('dataConsentRequired');
      if (dataConsentRequired === 'true') {
        localStorage.setItem('dataConsentAlreadyAccepted', 'true');
      }
        if (this.isSlackconnectRequested()) {
          window.location.href = (environment.urlForSlackConnect + '?userid=' + userid);
        }

        // Verify credentials first before initializing user account
        this.verifyAndInitializeUser(userid, sToken, uRole);

      } else if (!this.userAccountService.isLoggedIn() && currentSessionUser && currentSessionSToken) {
        if (this.isSlackconnectRequested()) {
          window.location.href = (environment.urlForSlackConnect + '?userid=' + currentSessionUser);
        }

        // Verify credentials first before initializing user account
        this.verifyAndInitializeUser(currentSessionUser, currentSessionSToken, currentSessionUserRole);

      } else if (!this.userAccountService.isLoggedIn()
        && !this.isLoginOrLogoutPage() && !CommonUtils.doesPathContain(currentUrl, 'emailAction')
        && !CommonUtils.doesPathContain(currentUrl, 'signup')) {
        if (!this.userAccountService.isLoginInProgress) {
          console.log('[DEBUG-RETURNPATH] Setting loginService.currentUrl =', currentUrl);
          this.loginService.currentUrl = currentUrl;
          this.loginService.userid = undefined;
          this.loginService.sToken = undefined;
          this.loginService.uRole = undefined;
          if (CommonUtils.doesPathContain(currentUrl,"bookingHistory")  && this.route.snapshot.queryParams['source'] && this.route.snapshot.queryParams['source'] == 'duplicateBookingEmail') {
            this.toastr.error("Sorry! You don't have relevant permission to view this itinerary");
          }
          this.router.navigateByUrl('/login');
          this.titleService.setTitle(this.translate.instant('login.Login'));
        }
      }
    } else if (CommonUtils.doesPathContain(currentUrl, 'emailAction')) {
      //this.titleService.setTitle('Reset Password');
      this.titleService.setTitle(this.translate.instant('search.ResetPassword'));
    }
  }

  private verifyAndInitializeUser(userid: string, sToken: string, uRole: string) {
    // Prevent concurrent verification attempts
    if (this.userAccountService.isLoginInProgress) {
      return;
    }

    this.userAccountService.isLoginInProgress = true;

    this.userAccountService.verifyCredentials(userid, sToken).subscribe(response => {
      if (response && response.success) {
        // Credentials verified successfully, proceed with initialization
        if (this.isSlackconnectRequested()) {
          window.location.href = (environment.urlForSlackConnect + '?userid=' + userid);
        }

        // Check if URL has zohoSSOMode and serviceurl params for Help Center SSO redirect
        const zohoSSOMode = this.route.snapshot.queryParamMap.get('zohoSSOMode');
        const serviceUrl = this.route.snapshot.queryParamMap.get('serviceurl');
        if (zohoSSOMode && serviceUrl) {
          this.loginService.callHelpCenterSSOAndRedirect(
            userid,
            sToken,
            decodeURIComponent(serviceUrl)
          );
          return;
        }

        this.userAccountService.initUserAccountService(userid, sToken, uRole, CommonUtils.doesPathContain(this.currentUrl, 'emailflow'));
        this.inItClientRequest();
        // If arriving from a cross-portal redirect with a return path, navigate there
        if (this._pendingReturnPath) {
          const returnPath = this._pendingReturnPath;
          this._pendingReturnPath = null;
          this.isNavigating = true;
          this.router.navigateByUrl(returnPath, { replaceUrl: true })
            .then(() => { this.isNavigating = false; });
        } else {
          // Only call goToHomePage if there are no meaningful query params (like type=allbookings)
          const currentQueryParams = this.route.snapshot.queryParams;
          const hasMeaningfulParams = currentQueryParams && (currentQueryParams['type'] || currentQueryParams['query'] || currentQueryParams['eventid']);
          if(this.router.url && this.router.url.split("?")[0] === this.userAccountService.getDefaultAppRoutePath() && !this.isNavigating && !hasMeaningfulParams) this.goToHomePage();
        }
      } else {
        // Credentials verification failed
        console.error('Credential verification failed:', response);
        this.userAccountService.isLoginInProgress = false;
        if (response.status === 403) {
          // Call signout utility for 403 errors
          CommonUtils.signout(this.userAccountService, this.gallopLocalStorage, this.loginService);
        }
        // Navigation to login is already handled in verifyCredentials for 403
        if (response.status !== 403) {
          this.userAccountService.clearLoggedInData();
          this.router.navigateByUrl('/login');
        }
      }
    });
  }

  /**
   * On page refresh, check if the user is on the correct portal deployment.
   * TM/Admin users belong on tmAppBaseUrl, regular users on bookingAppBaseUrl.
   * Called from both init config and user profile handlers — whichever fires
   * second will have all the data needed to make the redirect decision.
   */
  private checkAndRedirectToCorrectPortal() {
    if (this.userAccountService.njoySpecificBuild) return; // Not for mobile app
    if (this.isLoginOrLogoutPage() || this.isDashboardPage()) return;
    if (!this.userAccountService.isLoggedIn()) return;
    if (!this.userAccountService.getAccountInfo()) return;
    if (!this.clientConfig.bookingAppBaseUrl && !this.clientConfig.tmAppBaseUrl) return;

    const isTmOrAdmin = this.userAccountService.isUserIsTravelManager()
      || this.userAccountService.isUserCorporateAdmin();
    const targetPortal = this.clientConfig.getPortalBaseUrl(isTmOrAdmin);

    if (targetPortal && targetPortal !== window.location.origin) {
      const redirectToken = CommonUtils.base64EncodeRedirectToken(
        this.userAccountService.getUserEmail(),
        this.userAccountService.getSToken()
      );
      let redirectUrl = targetPortal + '/?redirect_token=' + redirectToken;
      // Preserve ALL query params from the current URL as top-level params in the redirect.
      // This covers eventid, type, query, and any other params the target portal needs.
      const currentSearch = window.location.search || '';
      if (currentSearch) {
        new URLSearchParams(currentSearch).forEach((value, key) => {
          if (key !== 'redirect_token' && key !== 'returnPath' && key !== 'userid' && key !== 'sToken') {
            redirectUrl += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value);
          }
        });
      }
      // Also forward selectedEventID if it was captured before the URL was cleaned
      if (this.searchService.selectedEventID
          && !redirectUrl.includes('eventid=')) {
        redirectUrl += '&eventid=' + encodeURIComponent(this.searchService.selectedEventID);
      }
      // Preserve full original path+params as returnPath for navigation on target portal.
      const currentPath = window.location.pathname;
      if (currentPath !== '/') {
        const hasQueryParams = currentSearch.length > 0;
        if (!CommonUtils.isBookingPagePath(currentPath) || hasQueryParams) {
          const returnPath = currentPath + currentSearch;
          redirectUrl += '&returnPath=' + encodeURIComponent(returnPath);
        }
      }
      window.location.href = redirectUrl;
    }
  }

  private storageEventListener(storeData: any) {
    if (storeData && storeData.key === 'loginSession') {
      let newLoginSession = undefined;
      let prevLoginSession = undefined;
      if (storeData.newValue && storeData.newValue != null) {
        newLoginSession = JSON.parse(storeData.newValue);
      }
      if (storeData.oldValue && storeData.oldValue != null) {
        prevLoginSession = JSON.parse(storeData.oldValue);
      }

      if (prevLoginSession && (!newLoginSession || (newLoginSession['userid'] !== prevLoginSession['userid'] && newLoginSession['sToken'] !== prevLoginSession['sToken']))) {
        if (this.bsModalRef
          && this.bsModalRef.content
          && this.bsModalRef.content.title
          && this.bsModalRef.content.title ===  this.translate.instant('search.SignedOut')) {
          return;
        }
        this.bsModalRef = this.modalService.show(DeleteCardModelComponent, {
          initialState: {
            title:this.translate.instant('search.SignedOut'),
            message: this.translate.instant('search.Youhavebeensignedoutof') + this.userAccountService.getUserEmail()
            + ' ' + this.translate.instant('search.account.'),
            yesButtonSubText: this.translate.instant('search.OK'),
            color: 'black',
            buttonColor: this.searchService.hyperlinkcolor,
            disableCancel: true,

          }, backdrop: true, keyboard: false, ignoreBackdropClick: true
        });
        this.bsModalRef.content.onClose.subscribe(result => {
          this.bsModalRef = null;
          if (result) {
            this.userAccountService.clearLoggedInData();
            this.attemptLoginSessionUpdate(undefined, undefined, undefined,this.currentUrl);
            //this.titleService.setTitle('Login');
            this.titleService.setTitle(this.translate.instant('login.Login'));
            const portalBase = this.clientConfig.getPortalBaseUrl(this.userAccountService.isUserIsTravelManager() || this.userAccountService.isUserCorporateAdmin());
            if(portalBase){
            window.location.href = (portalBase + '/logout');
            }else{
              if(this.bsModalRef){
                this.bsModalRef.hide();
              }
            }
          }
        });
      } else if (newLoginSession && newLoginSession['userid']) {
        this.attemptLoginSessionUpdate(undefined, undefined, undefined,this.currentUrl);
      }
    }
  }
  private inItClientRequest() {
    let userid = this.userAccountService.getUserEmail();
    let sToken = this.userAccountService.getSToken();
    //if(this.userAccountService.isLoggedIn()){
    this.userAccountService.initializeApiClient();

    //}
  }

  initLogin() {

  }
  ngOnDestroy() {
    this.gallopLocalStorage.clear();
  }
  airportModalOpen() {
    if (this.ngxSmartModalService.getOpenedModals() &&
      (this.ngxSmartModalService.getOpenedModals().length > 0 && this.isMobile)
    ) {
      let modals = this.ngxSmartModalService.getOpenedModals();
      if (modals[0].id.search('search') !== -1 || modals[0].id.search('dest') !== -1 || modals[0].id.search('mobile') !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }
  public handleClickEventForImplementingModalHack() {
    if (this.ngxSmartModalService.getOpenedModals() &&
      this.ngxSmartModalService.getOpenedModals().length > 0
    ) {
      let modals = this.ngxSmartModalService.getOpenedModals();
      for (let index = 0; index < modals.length; index++) {
        var currModalTimeStamps = getCurrentlyOpenNgxSmartModalIds();
        let helpModalAlreadyOpen = false;
        if (currModalTimeStamps[modals[index].id] &&
          new Date().getTime() - currModalTimeStamps[modals[index].id] > 500
        ) {
          if (modals[index].id !== 'helpModal') {
            this.ngxSmartModalService.getModal(modals[index].id).close();
            this.searchService.inputId = '';
            setNgxSmartModalOpenStateClosed(modals[index].id);
          } else {
            if ($('.modalAirportFilterInfo').css('display') !== 'none') {
              $('.modalAirportFilterInfo').slideToggle();
              setNgxSmartModalOpenStateClosed(modals[index].id);
            }
          }
        }
      }
    }
    return true;
  }
  public getWindowHeight() {
    return window.innerHeight + 'px';
  }
  public setTitle(title: string) {
    this.titleService.setTitle(title);
  }
  public closeCalendar() {
    if (this.currDatePicker) {
      setTimeout(() => {
        startEventsBehindCal();
      }, 500);
      this.currDatePicker.hide();
      this.currDatePicker = null;
      setTimeout(() => {
        startEventsBehindCal();
      }, 500);
    }
    return;
  }
  private checkForEventId(){
    if(this.currentParams['eventid'] && this.currentParams['eventid']!=='exitEvent'){
          this.searchService.selectedEventID = this.currentParams['eventid'];
         }
  }
}
